import type { NodeData, NodeId, NodeRecord } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { record } from 'fp-ts';
import { flow } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { makeMemoizeObject } from 'utils/memoize/makeMemoizeObject';
import { omit } from 'utils/object/omit';
import { createScopedSelector } from 'utils/react/scopedSelector';

export type NodeStableData = Omit<NodeData, 'position'>;

export type NodeStableDataRecord = Record<NodeId, NodeStableData>;

export const makeFilterNodePositionsMemoized = (): ((
  nodes: NodeRecord,
) => NodeStableDataRecord) => {
  const memoizeObject = makeMemoizeObject<NodeStableDataRecord>();
  return flow(record.map(omit(['position'])), memoizeObject);
};

/**
 * Drop frequently changed fields (currently only positions) from node record
 * to make more efficient subsequent selectors that don't need those dynamic data
 */
export const selectNodesStableData: (s: GraphState) => NodeStableDataRecord =
  createScopedSelector(() =>
    createSelector((s) => s.graph.nodes, makeFilterNodePositionsMemoized()),
  );
